import { repository, baseURL } from "@/api/base"

export default {
  async exportXlsxVacancy(body) {
    const formData = new FormData();
    formData.append('file', body)
    const { data } = await repository.post(baseURL + '/xlsx/exportXlsxVacancy', formData)
    return data
  },

  async importXlsxVacancy() {
    const { data } = await repository.get(baseURL + '/xlsx/importXlsxVacancy', { responseType: "arraybuffer" })
    return data
  },

  async exportXlsxTestScore(body) {
    const formData = new FormData();
    formData.append('file', body)
    const { data } = await repository.post(baseURL + '/xlsx/exportXlsxTestScore', formData)
    return data
  },

  async importXlsxTestScore() {
    const { data } = await repository.get(baseURL + '/xlsx/importXlsxTestScore', { responseType: "arraybuffer" })
    return data
  },
}
